// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2CxgK","fileBtn":"File_fileBtn__3eW41","closeBtn":"File_closeBtn__18gV7","fileSelected":"File_fileSelected__3eIqH","disabled":"File_disabled__730tA"};